/* 2026-10-10 Card "Add" feedback (Yusaku: "no reaction, can't tell it went in").
   Card Add buttons (collection/search grids .mochi-card-cta, and the collection quick-filter/search results .mochi-search-card)
   are handled here: add with /cart/add.js, button "Adding..." -> "Added", update the header cart counts, and show a small
   message with the item name and "View cart" (closes after 5 s, with ×, or with Esc).
   The Worker pixel (/track/pixel.js) used to do the adding, but it loads only after the whole page has loaded, and the
   quick-filter results were never covered (Yusaku 10/10, Chrome incognito: "nothing shows"). This listener runs first
   (window, capture) and stops the click, so the pixel never adds the same item twice. The watcher below stays as a
   fallback for any other button that turns "is-added". */
(function () {
  if (window.mochiCardAddedReady) return;
  window.mochiCardAddedReady = true;

  function setCount(count) {
    document.querySelectorAll('.mochi-global-header__cart-count,[data-mochi-menu-cart-count],[data-cart-count]').forEach(function (node) {
      node.textContent = String(count);
    });
    document.querySelectorAll('a.mochi-global-header__cart,a.mochi-global-header__mobile-quick-link[href$="/cart"]').forEach(function (a) {
      a.setAttribute('aria-label', 'Cart, ' + count + (count === 1 ? ' item' : ' items'));
      var spans = a.querySelectorAll('span');
      var last = spans[spans.length - 1];
      if (last && /^Cart \(\d+\)$/.test((last.textContent || '').trim())) last.textContent = 'Cart (' + count + ')';
    });
  }

  function toast(name, img, count, errorText) {
    var box = document.getElementById('mochi-card-toast');
    if (!box) {
      var st = document.createElement('style');
      st.textContent = '#mochi-card-toast{position:fixed;left:50%;bottom:24px;z-index:10000;transform:translateX(-50%);display:flex;align-items:center;gap:12px;width:min(440px,calc(100% - 32px));padding:12px 14px;border:1px solid #f3d3e1;border-radius:12px;background:#fff;box-shadow:0 8px 24px rgba(40,38,58,.18);color:#28263a;font-size:14px;line-height:1.4}' +
        '#mochi-card-toast[hidden]{display:none}#mochi-card-toast img{flex:0 0 48px;width:48px;height:48px;border-radius:8px;object-fit:contain;background:#f7f5f6}' +
        '#mochi-card-toast .mct-text{flex:1 1 auto;min-width:0}#mochi-card-toast strong{display:block;font-size:13px}' +
        '#mochi-card-toast .mct-name{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;color:#5f5d70;font-size:13px}' +
        '#mochi-card-toast a{flex:0 0 auto;display:inline-flex;align-items:center;min-height:44px;padding:0 14px;border-radius:999px;background:#b8325f;color:#fff;font-weight:700;text-decoration:none;white-space:nowrap}' +
        '#mochi-card-toast button{flex:0 0 32px;width:32px;height:32px;border:0;border-radius:50%;background:transparent;color:#77758a;font-size:20px;line-height:1;cursor:pointer}' +
        '#mochi-card-toast a:focus-visible,#mochi-card-toast button:focus-visible{outline:2px solid #b8325f;outline-offset:2px}';
      document.head.appendChild(st);
      box = document.createElement('div');
      box.id = 'mochi-card-toast';
      box.setAttribute('role', 'status');
      box.setAttribute('aria-live', 'polite');
      box.hidden = true;
      document.body.appendChild(box);
      document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && !box.hidden) box.hidden = true; });
    }
    box.innerHTML = '';
    if (img) { var im = document.createElement('img'); im.src = img; im.alt = ''; box.appendChild(im); }
    var text = document.createElement('div');
    text.className = 'mct-text';
    var head = document.createElement('strong');
    head.textContent = errorText ? errorText : 'Added to cart' + (typeof count === 'number' ? ' (' + count + (count === 1 ? ' item)' : ' items)') : '');
    text.appendChild(head);
    if (name) { var nm = document.createElement('span'); nm.className = 'mct-name'; nm.textContent = name; text.appendChild(nm); }
    box.appendChild(text);
    var link = document.createElement('a');
    link.href = (window.routes && window.routes.cart_url) || '/cart';
    link.textContent = 'View cart';
    box.appendChild(link);
    var close = document.createElement('button');
    close.type = 'button';
    close.setAttribute('aria-label', 'Close');
    close.textContent = '×';
    close.addEventListener('click', function () { box.hidden = true; });
    box.appendChild(close);
    box.hidden = false;
    clearTimeout(box.mochiTimer);
    box.mochiTimer = setTimeout(function () { if (!box.contains(document.activeElement)) box.hidden = true; }, 5000);
  }


  window.mochiCardToast = toast;
  var CARD_BUTTONS = '.mochi-card-cta__button, .mochi-search-card__button[type="submit"]';
  var st0 = document.createElement('style');
  st0.textContent = '.mochi-card-cta__button.is-loading,.mochi-search-card__button.is-loading{opacity:.78;cursor:progress}' +
    '.mochi-card-cta__button.is-added,.mochi-search-card__button.is-added{background:#8bd9b0!important;border-color:#8bd9b0!important;color:#fff!important;box-shadow:none!important}';
  document.head.appendChild(st0);

  function setLabel(button, text) {
    var first = button.querySelector('span');
    if (first) first.textContent = text; else button.textContent = text;
  }

  function cardInfo(button) {
    var card = button.closest('.card-wrapper') || button.closest('.mochi-search-card') || button.closest('li') || button.parentNode;
    var heading = card && card.querySelector('.card__heading, .mochi-search-card__title, h3, h2');
    var image = card && card.querySelector('.card__media img, .mochi-search-card__image img, img');
    return {
      name: heading ? (heading.textContent || '').replace(/\s+/g, ' ').trim() : '',
      img: image ? (image.currentSrc || image.src || '') : ''
    };
  }

  function addFromCard(button) {
    var form = button.closest('form');
    var idInput = form && form.querySelector('input[name="id"]');
    if (!idInput || !idInput.value || button.disabled || button.getAttribute('data-mochi-adding') === 'true') return;
    var original = button.getAttribute('data-mochi-original-label') || (button.querySelector('span') || button).textContent.trim() || 'Add';
    button.setAttribute('data-mochi-original-label', original);
    button.setAttribute('data-mochi-adding', 'true');
    button.setAttribute('data-mochi-added-shown', 'true');
    button.classList.remove('is-added');
    button.classList.add('is-loading');
    setLabel(button, 'Adding...');
    var info = cardInfo(button);
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: idInput.value, quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) return r.json().catch(function () { return {}; }).then(function (d) { throw new Error(d && d.description ? d.description : 'add failed'); });
        return r.json();
      })
      .then(function (item) {
        if (item && item.product_title && !info.name) info.name = item.product_title;
        return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        button.classList.remove('is-loading');
        button.classList.add('is-added');
        setLabel(button, 'Added');
        setCount(cart.item_count);
        toast(info.name, info.img, cart.item_count);
      })
      .catch(function (error) {
        button.classList.remove('is-loading');
        setLabel(button, 'Try again');
        toast('', '', null, (error && error.message) || 'This item could not be added. Please try again.');
        setTimeout(function () { if (!button.classList.contains('is-added')) setLabel(button, original); }, 2000);
      })
      .then(function () { button.removeAttribute('data-mochi-adding'); });
  }

  function onCardEvent(event) {
    var target = event.target;
    var button = event.type === 'submit'
      ? target && target.querySelector && target.querySelector(CARD_BUTTONS)
      : target && target.closest && target.closest(CARD_BUTTONS);
    if (!button || !button.closest('form')) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    if (event.type === 'click') addFromCard(button);
  }
  window.addEventListener('click', onCardEvent, true);
  window.addEventListener('submit', onCardEvent, true);

  function onAdded(button) {
    if (button.getAttribute('data-mochi-added-shown') === 'true') return;
    button.setAttribute('data-mochi-added-shown', 'true');
    var card = button.closest('.card-wrapper') || button.closest('li') || button.parentNode;
    var heading = card && card.querySelector('.card__heading, .card__heading a, h3, h2');
    var image = card && card.querySelector('.card__media img, img');
    var name = heading ? (heading.textContent || '').replace(/\s+/g, ' ').trim() : '';
    var img = image ? (image.currentSrc || image.src || '') : '';
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCount(cart.item_count); toast(name, img, cart.item_count); })
      .catch(function () { toast(name, img); });
  }

  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      var el = m.target;
      if (!el.classList || !el.classList.contains('is-added')) return;
      if (!el.matches('.mochi-card-cta__button, .add-cart')) return;
      onAdded(el);
    });
  }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['class'] });
})();

// 2026-10-10 トップのジャンル表示（Special Sets・Games など）の「Add to cart」（mochi-list-cart.js）でも同じお知らせを出す。
// あちらがカートに入れ終わると cartUpdate（source: mochi-list-cart）を出すので、押した商品の名前と写真を覚えておいて出す。
(function () {
  var last = null;
  window.addEventListener('submit', function (event) {
    var form = event.target && event.target.closest && event.target.closest('[data-mochi-list-cart]');
    if (!form) return;
    var card = form.closest('.mochi-shell__product') || form.closest('[data-mochi-cart-card]') || form.closest('article') || form.parentNode;
    var heading = card && card.querySelector('h3, h2, .mochi-shell__product-title, [class*="title"]');
    var image = card && card.querySelector('img');
    last = { name: heading ? (heading.textContent || '').replace(/\s+/g, ' ').trim() : '', img: image && (image.currentSrc || image.src) || '', at: Date.now() };
  }, true);
  function hook() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return false;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
      if (!ev || ev.source !== 'mochi-list-cart' || !last || Date.now() - last.at > 30000) return;
      var info = last; last = null;
      if (window.mochiCardToast) window.mochiCardToast(info.name, info.img, ev.cartData && typeof ev.cartData.item_count === 'number' ? ev.cartData.item_count : undefined);
    });
    return true;
  }
  if (!hook()) document.addEventListener('DOMContentLoaded', hook);
})();
